import React, { useState } from 'react';
import AccountProfile from '../AccountProfile';
import PopUpContainer from '../PopUpContainer';
import './navbar.scss';
export default function NavBar() {
  const [openAccount, setOpenAccount] = useState(false);
  return (
    <div
      className="navbar"
      style={{
        cursor: !openAccount ? 'pointer' : '',
      }}
      onClick={() => {
        if (!openAccount) setOpenAccount(true);
      }}
    >
      {openAccount ? (
        <PopUpContainer>
          <AccountProfile setOpenAccount={setOpenAccount} />
        </PopUpContainer>
      ) : (
        'MY ACCOUNT'
      )}
    </div>
  );
}
